function PageSubtitle (props) {

  return(
    <div style={{
         textAlign: 'center',
         color: '#fff',
         fontSize: '24px',
         fontWeight: '600',
         margin: '10px 0 40px 0',
       }}>
      {props.pageSubtitle}
    </div>
  )
}

export default PageSubtitle
